<template>
  <section>
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <div class="searchBox">
      <el-select
        placeholder="请选择订单类型"
        clearable
        v-model="filterParam.OrderType"
        style="margin-right: 10px"
      >
        <el-option :value="10" label="订场"></el-option>
        <el-option :value="20" label="赛事"></el-option>
        <el-option :value="30" label="会员卡"></el-option>
        <el-option :value="40" label="优选商品"></el-option>
        <el-option :value="50" label="报名卡"></el-option>
      </el-select>
      <el-select
        placeholder="请选择订单状态"
        clearable
        v-model="filterParam.OrderStatus"
        style="margin-right: 10px"
      >
        <el-option :value="10" label="已下单未支付"></el-option>
        <el-option :value="20" label="取消订单"></el-option>
        <el-option :value="30" label="支付成功"></el-option>
        <el-option :value="40" label="待发货"></el-option>
        <el-option :value="45" label="待收货/使用"></el-option>
        <el-option :value="50" label="待评价"></el-option>
        <el-option :value="56" label="已退款"></el-option>
      </el-select>
      <el-input
        style="width: 200px; margin-right: 10px"
        v-model="filterParam.SearchValue"
        placeholder="请输入搜索内容"
      ></el-input>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button type="primary" @click="handleReset">重置</el-button>
      <el-button type="primary" @click="exportXlsx">导出</el-button>
    </div>
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      class="custom-tbl"
    >
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="WxUserInfoName" label="用户名称"></el-table-column>
      <el-table-column prop="OrderNum" label="订单号"></el-table-column>
      <el-table-column prop="BuisnessNum" label="商品号">
        <template slot-scope="scope">
          {{ scope.row.BuisnessNum }}
        </template>
      </el-table-column>
      <el-table-column
        prop="OrderType"
        label="订单类型"
        :formatter="formatType"
        align="center"
      ></el-table-column>
      <!-- <el-table-column prop="Price" label="订单金额"></el-table-column> -->
      <el-table-column
        prop="TotalPrice"
        label="总金额(元)"
        align="center"
      ></el-table-column>
      <!-- <el-table-column
        prop="PaymentSerialNum"
        label="支付流水号(微信支付)"
      ></el-table-column> -->
      <el-table-column label="支付方式">
        <template slot-scope="scope">
          <span v-if="scope.row.IsCombinPay"> 组合支付 </span>
          <span v-else>
            {{ scope.row.PaymentSerialNum ? "微信支付" : "工会卡支付" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Status"
        label="订单状态"
        :formatter="formatStatus"
        align="center"
      ></el-table-column>
      <el-table-column prop="PayTime" label="支付时间"></el-table-column>
      <el-table-column prop="Remark" label="备注"></el-table-column>
      <el-table-column label="操作" width="250" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="logisticsSetting(scope.row)"
            v-if="scope.row.OrderType == 40 && scope.row.Status == 40"
          >
            物流配置
          </el-button>
          <el-button
            type="primary"
            size="mini"
            @click="sendDeliveryConfirmationMessage(scope.row.Id)"
            v-if="
              scope.row.OrderType == 40 &&
              scope.row.Status == 45 &&
              scope.row.IsCity !== true
            "
          >
            收货提醒
          </el-button>
          <el-button plain size="mini" @click="handleDetail(scope.row)">
            查看
          </el-button>
          <el-button type="danger" size="mini" @click="handleDel(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
    <el-dialog
      title="订单详情"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      width="1100px"
      class="order-detail-dialog"
    >
      <el-card shadow="never" class="detail-card">
        <div slot="header">
          <span class="detail-card-title">基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="detail-item">
              <span class="detail-label">订单号：</span>
              <span class="detail-value">{{ detail.OrderNum }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <span class="detail-label">支付流水号：</span>
              <span class="detail-value">{{
                detail.PaymentSerialNum || "暂无"
              }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <span class="detail-label">订单类型：</span>
              <span class="detail-value">{{
                formatType(null, null, detail.OrderType)
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="mt20">
          <el-col :span="8">
            <div class="detail-item">
              <span class="detail-label">用户昵称：</span>
              <span class="detail-value">{{ detail.WxUserInfoName }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <span class="detail-label">微信用户ID：</span>
              <span class="detail-value">{{ detail.WxUserInfoId }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <span class="detail-label">订单状态：</span>
              <span class="detail-value">{{
                formatStatus(null, null, detail.Status)
              }}</span>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <el-card shadow="never" class="detail-card mt20">
        <div slot="header">
          <span class="detail-card-title">金额信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="detail-label">支付金额：</span>
              <span class="detail-value price-value">￥{{ detail.Price }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="detail-label">总金额：</span>
              <span class="detail-value price-value"
                >￥{{ detail.TotalPrice }}</span
              >
            </div>
          </el-col>
        </el-row>
      </el-card>

      <el-card shadow="never" class="detail-card mt20">
        <div slot="header">
          <span class="detail-card-title">时间信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="detail-item">
              <span class="detail-label">创建时间：</span>
              <span class="detail-value">{{ detail.CreateTime }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <span class="detail-label">支付时间：</span>
              <span class="detail-value">{{ detail.PayTime || "未支付" }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <span class="detail-label">超时时间：</span>
              <span class="detail-value">{{ detail.OrderTimeOut }}</span>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <el-card shadow="never" class="detail-card mt20">
        <div slot="header">
          <span class="detail-card-title">商品信息</span>
        </div>
        <div v-if="parsedBusinessData">
          <!-- 订场 -->
          <div v-if="detail.OrderType == 10" class="business-info">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">场馆名称：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.CourtName || "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">预订日期：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.ReserveDate || "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">开始时间：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.StartTime || "暂无"
                  }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="mt10">
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">结束时间：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.EndTime || "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">场地名称：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.FieldName || "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">价格：</span>
                  <span class="detail-value price-value"
                    >￥{{ parsedBusinessData.Price || "0" }}</span
                  >
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 赛事 -->
          <div v-else-if="detail.OrderType == 20" class="business-info">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">赛事名称：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.MatchName || "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">赛事日期：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.MatchDate || "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">赛事地点：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.MatchLocation || "暂无"
                  }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="mt10">
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">报名费用：</span>
                  <span class="detail-value price-value"
                    >￥{{ parsedBusinessData.Price || "0" }}</span
                  >
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 会员卡 -->
          <div v-else-if="detail.OrderType == 30" class="business-info">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">会员卡名称：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.CardName || "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">有效期：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.ValidityPeriod || "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">卡类型：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.CardType || "暂无"
                  }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="mt10">
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">价格：</span>
                  <span class="detail-value price-value"
                    >￥{{ parsedBusinessData.Price || "0" }}</span
                  >
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 优选商品 -->
          <div v-else-if="detail.OrderType == 40" class="business-info">
            <div
              v-if="parsedBusinessData.PreferredProducts"
              class="product-details"
            >
              <div class="product-header">
                <div
                  class="product-image"
                  v-if="parsedBusinessData.PreferredProducts.CoverPicture"
                >
                  <img
                    :src="parsedBusinessData.PreferredProducts.CoverPicture"
                    alt="商品图片"
                  />
                </div>
                <div class="product-basic-info">
                  <h3 class="product-name">
                    {{
                      parsedBusinessData.PreferredProducts.Name ||
                      "暂无商品名称"
                    }}
                  </h3>
                  <div class="product-code">
                    商品编码：{{
                      parsedBusinessData.PreferredProducts.ProductsCode ||
                      "暂无"
                    }}
                  </div>
                  <div class="product-type">
                    商品类型：{{
                      parsedBusinessData.PreferredProducts.ProductsType ||
                      "暂无"
                    }}
                  </div>
                </div>
              </div>

              <el-divider></el-divider>

              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">购买数量：</span>
                    <span class="detail-value"
                      >{{ parsedBusinessData.Num || "0" }} 件</span
                    >
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">商品单价：</span>
                    <span class="detail-value price-value"
                      >￥{{
                        parsedBusinessData.PreferredProducts.Price || "0"
                      }}</span
                    >
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">所选尺寸：</span>
                    <span class="detail-value">
                      {{ parsedBusinessData.Size || "" }}
                    </span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">所选颜色：</span>
                    <span class="detail-value">
                      {{ parsedBusinessData.Color || "" }}
                    </span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="mt10">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">商品总价：</span>
                    <span class="detail-value price-value"
                      >￥{{ parsedBusinessData.Price || "0" }}</span
                    >
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">运费：</span>
                    <span class="detail-value"
                      >￥{{
                        parsedBusinessData.PreferredProducts
                          .ExpressDeliveryPrice || "0"
                      }}</span
                    >
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="mt10">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="detail-label">发货时间：</span>
                    <span class="detail-value">{{
                      parsedBusinessData.PreferredProducts.DeliveryTime ||
                      "暂无"
                    }}</span>
                  </div>
                </el-col>
              </el-row>

              <el-divider content-position="left">收货信息</el-divider>

              <div
                v-if="
                  parsedBusinessData.OrderBuisness &&
                  parsedBusinessData.OrderBuisness.length > 0
                "
              >
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="detail-label">收货人：</span>
                      <span class="detail-value">{{
                        parsedBusinessData.OrderBuisness[0].Name || "暂无"
                      }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="detail-label">联系电话：</span>
                      <span class="detail-value">{{
                        parsedBusinessData.OrderBuisness[0].TelPhone || "暂无"
                      }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="mt10">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="detail-label">所在地区：</span>
                      <span class="detail-value">{{
                        parsedBusinessData.OrderBuisness[0]
                          .LocationRegionInfo || "暂无"
                      }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="detail-label">详细地址：</span>
                      <span class="detail-value">{{
                        parsedBusinessData.OrderBuisness[0].Adress || "暂无"
                      }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div v-else>
                <el-empty description="暂无收货信息"></el-empty>
              </div>

              <el-divider content-position="left">发货信息</el-divider>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="detail-item">
                    <span class="detail-label">发货地址：</span>
                    <span class="detail-value">{{
                      parsedBusinessData.PreferredProducts.SendOutAdress ||
                      "暂无"
                    }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-else>
              <pre class="json-display">{{ detail.BussinessData }}</pre>
            </div>
          </div>

          <!-- 报名卡 -->
          <div v-else-if="detail.OrderType == 50" class="business-info">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">报名卡名称：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.EnrollCardName || "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">适用赛事：</span>
                  <span class="detail-value">{{
                    parsedBusinessData.ApplicableMatch || "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="detail-item">
                  <span class="detail-label">卡面值：</span>
                  <span class="detail-value price-value"
                    >￥{{ parsedBusinessData.FaceValue || "0" }}</span
                  >
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 其他类型或无法解析的情况 -->
          <div v-else class="business-info">
            <pre class="json-display">{{ detail.BussinessData }}</pre>
          </div>
        </div>
        <div v-else class="business-info">
          <pre class="json-display">{{ detail.BussinessData }}</pre>
        </div>
      </el-card>

      <el-card shadow="never" class="detail-card mt20" v-if="detail.Remark">
        <div slot="header">
          <span class="detail-card-title">备注信息</span>
        </div>
        <div class="detail-item">
          <span class="detail-value remark-content">{{ detail.Remark }}</span>
        </div>
      </el-card>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="物流信息配置"
      :visible.sync="logisticsFormVisible"
      v-model="logisticsFormVisible"
      :close-on-click-modal="false"
      width="650px"
    >
      <el-form
        :model="logisticsForm"
        label-width="100px"
        :rules="logisticsFormRules"
        ref="logisticsForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="配送方式" prop="LogisticsCompanyName">
              <el-select
                v-model="logisticsForm.LogisticsCompanyName"
                placeholder="请选择配送方式"
                filterable
                style="width: 100%"
                @change="onLogisticsCompanyNameChange"
              >
                <el-option
                  v-for="item in LogisticsCompanyNameOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发货时间" prop="DeliveryTime">
              <el-date-picker
                v-model="logisticsForm.DeliveryTime"
                type="datetime"
                placeholder="选择发货时间"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 同城配送时显示骑手信息和发货人信息 -->
        <template v-if="isLocalDelivery">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="发货人" prop="Shipper">
                <el-input
                  v-model="logisticsForm.Shipper"
                  placeholder="请输入发货人"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="TelPhone">
                <el-input
                  v-model="logisticsForm.TelPhone"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="骑手姓名" prop="Rider">
                <el-input
                  v-model="logisticsForm.Rider"
                  placeholder="请输入骑手姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="骑手电话" prop="RiderPhone">
                <el-input
                  v-model="logisticsForm.RiderPhone"
                  placeholder="请输入骑手电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="发货地址" prop="ShippingAddress">
                <el-input
                  v-model="logisticsForm.ShippingAddress"
                  placeholder="请输入发货地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <!-- 快递配送时显示快递信息 -->
        <template v-else>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="物流单号" prop="LogisticsNumber">
                <el-input
                  v-model="logisticsForm.LogisticsNumber"
                  placeholder="请输入物流单号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发货人" prop="Shipper">
                <el-input
                  v-model="logisticsForm.Shipper"
                  placeholder="请输入发货人"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="联系电话" prop="TelPhone">
                <el-input
                  v-model="logisticsForm.TelPhone"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发货地址" prop="ShippingAddress">
                <el-input
                  v-model="logisticsForm.ShippingAddress"
                  placeholder="请输入发货地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="logisticsFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitLogistics">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import {
  orderList,
  deleteOrder,
  orderDetail,
  PostUpdateLogisticsInfo,
  GetSelectLogistics,
} from "@/api/product/product";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  SendDeliveryConfirmationMessage,
  PostExportOrderExcel,
} from "@/api/Order/Order";
import { downloadXls, dateNow } from "@/utils/util.js";
export default {
  components: { Toolbar },
  data() {
    return {
      filters: {},
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {},
      //新增界面数据
      addForm: {},
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {},
      //编辑界面数据
      editForm: {},
      filterParam: {},
      detail: {},
      // 物流信息配置相关
      logisticsFormVisible: false,
      logisticsForm: {
        id: null,
        OrderId: null,
        LogisticsNumber: "", // 物流单号
        LogisticsCompanyName: "", // 物流公司
        DeliveryTime: "", // 发货时间
        Shipper: "", // 发货人
        TelPhone: "", // 联系电话
        ShippingAddress: "", // 发货地址
        Rider: "", // 骑手姓名
        RiderPhone: "", // 骑手电话
      },
      logisticsFormRules: {
        LogisticsCompanyName: [
          { required: true, message: "请选择配送方式", trigger: "blur" },
        ],
        DeliveryTime: [
          { required: true, message: "请选择发货时间", trigger: "change" },
        ],
        ShippingAddress: [
          { required: true, message: "请输入地址", trigger: "blur" },
        ],
      },
      currentOrder: null,
      // 常用物流公司列表
      LogisticsCompanyNameOptions: [
        { value: "同城配送", label: "同城配送" },
        { value: "顺丰速运", label: "顺丰速运" },
        { value: "中通快递", label: "中通快递" },
        { value: "圆通速递", label: "圆通速递" },
        { value: "申通快递", label: "申通快递" },
        { value: "韵达速递", label: "韵达速递" },
        { value: "百世快递", label: "百世快递" },
        { value: "EMS", label: "EMS" },
        { value: "京东物流", label: "京东物流" },
        { value: "德邦快递", label: "德邦快递" },
        { value: "邮政快递包裹", label: "邮政快递包裹" },
      ],
    };
  },
  computed: {
    parsedBusinessData() {
      try {
        if (this.detail.BussinessData) {
          if (typeof this.detail.BussinessData === "string") {
            return JSON.parse(this.detail.BussinessData);
          } else {
            return this.detail.BussinessData;
          }
        }
        return null;
      } catch (error) {
        console.error("解析商品信息失败:", error);
        return null;
      }
    },
    // 判断是否为同城配送
    isLocalDelivery() {
      return this.logisticsForm.LogisticsCompanyName === "同城配送";
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
  },
  methods: {
    formatType(row, column, cellValue, index) {
      switch (cellValue) {
        case 10:
          return "订场";
        case 20:
          return "赛事";
        case 30:
          return "会员卡";
        case 40:
          return "优选商品";
        case 50:
          return "报名卡";
      }
    },
    formatStatus(row, column, cellValue, index) {
      switch (cellValue) {
        case 10:
          return "待支付";
        case 20:
          return "已取消";
        case 30:
          return "已支付";
        case 40:
          return "待发货";
        case 45:
          return "待收货/使用";
        case 50:
          return "待评价";
        case 51:
          return "已完成";
        case 56:
          return "已退款";
      }
    },
    handleSearch() {
      this.initPage();
      this.getList();
    },
    handleReset() {
      this.filterParam = {};
      this.initPage();
      this.getList();
    },
    handleDetail(row) {
      orderDetail({
        OrderNum: row.OrderNum,
      }).then((res) => {
        this.detail = res.data.response;
        this.addFormVisible = true;
      });
    },
    handleDel(row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          return deleteOrder({
            Id: row.Id,
          });
        })
        .then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          }
        });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },
    getList() {
      this.listLoading = true;
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
        ...this.filterParam,
      };

      orderList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    async logisticsSetting(row) {
      this.currentOrder = row;
      this.logisticsForm = {
        id: null,
        OrderId: this.currentOrder.Id,
        LogisticsNumber: "",
        LogisticsCompanyName: "",
        DeliveryTime: "",
        Shipper: "",
        TelPhone: "",
        ShippingAddress: "",
        Rider: "",
        RiderPhone: "",
      };
      if (this.currentOrder.IsHaveLogistics) {
        const res = await GetSelectLogistics({ OrderId: this.currentOrder.Id });
        this.logisticsForm = {
          id: res.data.response.Id || null,
          OrderId: res.data.response.OrderId || null,
          LogisticsNumber: res.data.response.LogisticsNumber || "",
          LogisticsCompanyName: res.data.response.LogisticsCompanyName || "",
          DeliveryTime: res.data.response.DeliveryTime || "",
          Shipper: res.data.response.Shipper || "",
          TelPhone: res.data.response.TelPhone || "",
          ShippingAddress: res.data.response.ShippingAddress || "",
          Rider: res.data.response.Rider || "",
          RiderPhone: res.data.response.RiderPhone || "",
        };
      }
      this.logisticsFormVisible = true;
    },
    // 配送方式切换处理
    onLogisticsCompanyNameChange(value) {
      // 清空表单验证
      this.$nextTick(() => {
        this.$refs.logisticsForm.clearValidate();
      });

      // 根据配送方式动态设置验证规则
      if (value === "同城配送") {
        // 同城配送需要发货人信息和骑手信息
        this.$set(this.logisticsFormRules, "Shipper", [
          { required: true, message: "请输入发货人", trigger: "blur" },
        ]);
        this.$set(this.logisticsFormRules, "TelPhone", [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ]);
        this.$set(this.logisticsFormRules, "Rider", [
          { required: true, message: "请输入骑手姓名", trigger: "blur" },
        ]);
        this.$set(this.logisticsFormRules, "RiderPhone", [
          { required: true, message: "请输入骑手电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ]);
        // 清空快递相关字段
        this.logisticsForm.LogisticsNumber = "";
        // 移除快递相关验证规则
        this.$delete(this.logisticsFormRules, "LogisticsNumber");
      } else {
        // 快递配送需要快递信息
        this.$set(this.logisticsFormRules, "LogisticsNumber", [
          { required: true, message: "请输入物流单号", trigger: "blur" },
        ]);
        this.$set(this.logisticsFormRules, "Shipper", [
          { required: true, message: "请输入发货人", trigger: "blur" },
        ]);
        this.$set(this.logisticsFormRules, "TelPhone", [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ]);
        // 清空骑手相关字段
        this.logisticsForm.Rider = "";
        this.logisticsForm.RiderPhone = "";
        // 移除骑手相关验证规则
        this.$delete(this.logisticsFormRules, "Rider");
        this.$delete(this.logisticsFormRules, "RiderPhone");
      }
    },
    submitLogistics() {
      this.$refs.logisticsForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交物流信息?", "提示", {
            type: "warning",
          })
            .then(async () => {
              // 这里添加提交物流信息的API调用
              // 例如：updateLogistics({...this.logisticsForm, orderId: this.currentOrder.Id})
              let parameters = {
                Id: this.logisticsForm.id,
                OrderId: this.logisticsForm.OrderId,
                LogisticsNumber: this.logisticsForm.LogisticsNumber,
                LogisticsCompanyName: this.logisticsForm.LogisticsCompanyName,
                ShippingAddress: this.logisticsForm.ShippingAddress,
                DeliveryTime: this.logisticsForm.DeliveryTime,
                Shipper: this.logisticsForm.Shipper,
                TelPhone: this.logisticsForm.TelPhone,
                Rider: this.logisticsForm.Rider,
                RiderPhone: this.logisticsForm.RiderPhone,
                LogisticsType: this.isLocalDelivery ? 2 : 1,
              };
              console.log(parameters);
              const res = await PostUpdateLogisticsInfo(parameters);
              if (res.data.response) {
                this.$message({
                  message: "物流信息配置成功",
                  type: "success",
                });
                this.logisticsFormVisible = false;
                this.getList();
              } else {
                this.$message({
                  message: res.data.msg || "物流信息配置失败",
                  type: "error",
                });
              }
              // 刷新列表
            })
            .catch(() => {});
        }
      });
    },
    // 收货提醒功能
    sendDeliveryConfirmationMessage(orderId) {
      this.$confirm("确认发送收货提醒消息?", "提示", {
        type: "warning",
      })
        .then(() => {
          return SendDeliveryConfirmationMessage(orderId);
        })
        .then((res) => {
          if (res.data && res.data.success) {
            this.$message({
              message: "收货提醒发送成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: (res.data && res.data.msg) || "收货提醒发送失败",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.error("发送收货提醒失败:", error);
          this.$message({
            message: "发送收货提醒失败，请稍后重试",
            type: "error",
          });
        });
    },
    // 导出
    exportXlsx() {
      PostExportOrderExcel({ ...this.filterParam })
        .then((res) => {
          if (res && res.data) {
            downloadXls(res.data, `订单记录表${dateNow()}.xlsx`);
          } else {
            console.error("导出失败，未获取到数据");
          }
        })
        .catch((error) => {
          console.error("导出失败", error);
        });
    },
  },
};
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.searchBox {
  display: flex;
  align-items: center;
  margin: 20px;
}

/* 订单详情弹窗样式 */
.order-detail-dialog /deep/ .el-dialog__body {
  padding: 20px;
}

.detail-card {
  margin-bottom: 10px;
}

.detail-card-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.detail-item {
  display: flex;
  margin-bottom: 10px;
  line-height: 24px;
}

.detail-label {
  color: #909399;
  min-width: 90px;
  text-align: right;
  margin-right: 10px;
}

.detail-value {
  color: #606266;
  flex: 1;
  word-break: break-all;
}

.price-value {
  font-weight: bold;
  color: #f56c6c;
}

.remark-content {
  background: #f8f8f8;
  padding: 10px;
  border-radius: 4px;
  min-height: 40px;
}

.mt20 {
  margin-top: 20px;
}

.mt10 {
  margin-top: 10px;
}

.business-info {
  padding: 10px 0;
}

.json-display {
  background-color: #f8f8f8;
  padding: 10px;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-all;
  font-family: monospace;
  max-height: 300px;
  overflow-y: auto;
}

.product-details {
  margin: 10px 0;
}

.product-header {
  display: flex;
  margin-bottom: 15px;
}

.product-image {
  width: 100px;
  height: 100px;
  margin-right: 20px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-basic-info {
  flex: 1;
}

.product-name {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 10px 0;
}

.product-code,
.product-type {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}

.el-divider {
  margin: 15px 0;
}
</style>
